<template>
  <div :class="$style.progress_cell">
    <div :class="$style.indicator_background">
      <div
        :class="$style.progress_line"
        :style="{width: percentageCss }"
      />
    </div>
    <div :class="$style.value">{{ progressValue }} %</div>
  </div>
</template>

<script>
export default {
  props: {
    cell: { type: Object, required: true },
  },
  data() {
    return {};
  },
  computed: {
    cellData() {
      return this.cell.row.original[this.cell.column.id];
    },
    progressValue() {
      return this.cellData.percentage
    },
    percentageCss() {
      return `${this.progressValue}%`;
    },
  },
};
</script>

<style module src="./cell.less" lang="less"></style>
